import React from "react";
import {
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonMenu,
    IonMenuToggle,
    IonTitle,
    IonToolbar, useIonRouter
} from "@ionic/react";
import {server, time, people, arrowBack, layers} from "ionicons/icons";
import {useQuery} from "@tanstack/react-query";
import {getTime} from "../../repositories/adminTimeRepository";

export const AdminPageMenu: React.FC = () => {
    const router = useIonRouter();

    const timeQuery = useQuery({
        queryKey: ['serverTime'],
        queryFn: () => getTime(),
        refetchInterval: 1000,
    });

    return (
        <IonMenu contentId="main-content">
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Admin</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonList>
                    <IonMenuToggle>
                        <IonItem>
                            <IonIcon slot="start" icon={server}></IonIcon><IonLabel>{ timeQuery.status === 'error' ? 'Loading...' : timeQuery.data }</IonLabel>
                        </IonItem>
                        <IonItem>
                            <IonIcon slot="start" icon={time}></IonIcon><IonLabel>{new Date().toISOString()}</IonLabel>
                        </IonItem>
                        <IonItem button onClick={() => router.push("/admin/users")}>
                            <IonIcon slot="start" icon={people}></IonIcon><IonLabel>Users</IonLabel>
                        </IonItem>
                        <IonItem button onClick={() => router.push("/admin/serviceTypes")}>
                            <IonIcon slot="start" icon={layers}></IonIcon><IonLabel>Service types</IonLabel>
                        </IonItem>
                        <IonItem button onClick={() => router.push("/", "root", "replace")}>
                            <IonIcon slot="start" icon={arrowBack}></IonIcon><IonLabel>Go back to website</IonLabel>
                        </IonItem>
                    </IonMenuToggle>
                </IonList>
            </IonContent>
        </IonMenu>
    )
}